export const EOrderStatusType = {
  Pending: 0,

  Preparing: 1,

  PreparingFinished: 2,

  InDelivery: 3,

  Delivered: 4,

  WaitingOnlinePayment: 5,
} as const

export type EOrderStatusType = (typeof EOrderStatusType)[keyof typeof EOrderStatusType]
